import React, { forwardRef, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  InputGroup, Dropdown, Spinner, Badge, Form,
} from 'react-bootstrap';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DropContainerButton = styled(InputGroup)`
   div button {
      background-color: var(--backgroundButton) !important;
      color: var(--colorTextButton)!important;
        &:hover {
          background-color: var(--hoverButton) !important;
        };
    };
  div div {
    // transform: translate3d(0px, 38px, 0px) !important;
    right: 0 !important;
    left: auto !important;
    width: 100% !important;
    };
`;

export const valuePropType = PropTypes
  .oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.shape({}),
  ]);

const MultiSelector = forwardRef(({
  id, value, values, onChange, disabled, readOnly,
  isLoading, onDropDown, errors,
  className, errorAsTooltip, onFocus, onBlur,
}, ref) => {
  const [show, setShow] = useState(false);
  const displayValue = useMemo(
    () => {
      if (!value) return [];
      return value.map((cur) => values.reduce((R, v) => (v.value === cur ? v.display_name : R), ''));
    },
    [values, value],
  );

  const errored = !!errors && !!errors.length;
  const dicClassName = useMemo(
    () => `${className} form-control ${errored ? 'is-invalid' : ''}`,
    [className, errored],
  );
  return (
    <DropContainerButton className={className}>
      <div
        id={id}
        ref={ref}
        className={dicClassName}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {displayValue.map((v) => (
          <Badge key={v} variant="light" pill>{v}</Badge>
        ))}
      </div>
      {isLoading && (
      <InputGroup.Text>
        <Spinner animation="grow" size="sm" />
      </InputGroup.Text>
      )}
      <Dropdown
        style={{ position: 'unset' }}
        show={show}
        onToggle={(isOpen, e, md) => {
          if (md ? md.source !== 'select' : true) setShow(!show);
          if (isOpen && onDropDown) onDropDown(e, md);
        }}
        onSelect={(eventKey, e) => {
          const idx = parseInt(eventKey, 10) - 1;
          const vv = values[idx].value;

          if (!value) onChange(e, [vv]);
          else if (value.includes(vv)) onChange(e, value.filter((v) => v !== vv));
          else onChange(e, [...value, vv]);
        }}
      >
        <Dropdown.Toggle id={`drdn-${id}`} variant="falcon-secondary" disabled={disabled || readOnly} split />
        <Dropdown.Menu align="end" style={{ maxHeight: '20em' }} className="scrollbar">
          {values.map((vv, idx) => (
            <Dropdown.Item
              key={vv.value}
              disabled={vv.disabled}
              // onClick={(e) => onChange(e, [...new Set([...value, vv.value])])}
              eventKey={idx + 1}
            >
              {(value || []).includes(vv.value) ? (
                <FontAwesomeIcon icon={faCheck} size="xs" className="me-2" color="green" />
              ) : (
                <FontAwesomeIcon icon={faMinus} size="xs" className="me-2" color="#FFEEEE" />
              )}
              {vv.display_name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      {errors && (
      <Form.Control.Feedback type="invalid" tooltip={errorAsTooltip}>
        {errors.join(', ')}
      </Form.Control.Feedback>
      )}
    </DropContainerButton>
  );
});

MultiSelector.propTypes = {
  id: PropTypes.string,
  value: PropTypes.arrayOf(valuePropType),
  values: PropTypes.arrayOf(PropTypes.shape({
    value: valuePropType,
    disabled: PropTypes.bool,
    display_name: PropTypes.string,
  })),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  onDropDown: PropTypes.func,
  errors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  errorAsTooltip: PropTypes.bool,
};

MultiSelector.defaultProps = {
  id: '',
  value: [],
  values: [],
  onChange: () => null,
  disabled: false,
  readOnly: false,
  isLoading: false,
  onDropDown: null,
  errors: null,
  onFocus: null,
  onBlur: null,
  className: null,
  errorAsTooltip: false,
};

export default MultiSelector;
